import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useEffect, useState, useMemo } from "react";
import { AmountFormatCell } from "components/common/formatter";
import { NumericCell } from "./DisbursementInputField";
import { DateFormatCell } from "components/common/formatter";
import { process } from "@progress/kendo-data-query";
const initialDataState = {
  sort: [{ field: "date", dir: "asc" }],
  take: 50,
  skip: 0,
};
const DisbursementGrid = (props) => {
  const [dataState, setDataState] = useState(initialDataState);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (props.data) setData(props.data);
  }, [props.data]);

  const dataStateChange = (e) => {
    if (
      e.dataState.sort !== undefined &&
      e.dataState.skip !== 0 &&
      dataState.sort !== e.dataState.sort
    ) {
      setDataState({ ...e.dataState, skip: 0 });
    } else if (e.dataState.sort[0] === undefined) {
      setDataState({
        ...e.dataState,
        sort: [
          {
            field: dataState.sort[0].field,
            dir: "asc",
          },
        ],
      });
    } else {
      setDataState(e.dataState);
    }
  };

  const mergeAllocation = () => {
    const result = [];
    data.map((item) => {
      if (item.add === true) {
        const data = {
          postingId: item.postingId,
          amount: item.amount,
        };
        result.push(data);
      }
    });
    props.updateAllocations(result);
  };

  const AmountNameHeader = (props) => {
    return (
      <div
        onClick={(e) => {
          props.onClick(e);
        }}
        style={{ textAlign: "center", cursor: "pointer" }}>
        {props.title}
        {props.children}
      </div>
    );
  };

  const totalAllocatingAmount = useMemo(() => {
    return data.reduce((total, item) => {
      if (item.add === true && item.amount !== null && item.amount !== undefined) {
        return total + parseFloat(item.amount || 0);
      }
      return total;
    }, 0);
  }, [data]);

  useEffect(() => {
    mergeAllocation();
  }, [data]);

  const itemChange = (e) => {
    let newData = data.map((item) => {
      if (item.transactionNo === e.dataItem.transactionNo) {
        if (
          e.field === "amount" &&
          e.value <= item.amountDue &&
          item.amountDue >= 0
        ) {
          item[e.field || ""] = e.value;
        } else if (
          e.field === "amount" &&
          e.value < 0 &&
          e.value > item.amountDue &&
          item.amountDue < 0
        ) {
          item[e.field || ""] = e.value;
        } else if (e.field === "add") {
          item[e.field || ""] = e.value;
        }
      }
      return item;
    });
    setData(newData);
    if (e.field === "amount") {
      if (
        e.dataItem.amount !== 0 &&
        e.dataItem.amount !== null &&
        e.dataItem.add === false
      ) {
        let newData = data.map((item) => {
          if (item.transactionNo === e.dataItem.transactionNo) {
            item.add = true;
          }
          return item;
        });
        setData(newData);
      } else if (
        (e.dataItem.amount === 0 || e.dataItem.amount === null) &&
        e.dataItem.add === true
      ) {
        let newData = data.map((item) => {
          if (item.transactionNo === e.dataItem.transactionNo) {
            item.add = false;
          }
          return item;
        });
        setData(newData);
      }
    }
    if (e.field === "add") {
      if (e.dataItem.add === true) {
        let newData = data.map((item) => {
          if (item.postingId === e.dataItem.postingId) {
            item.amount = item.amountDue;
          }
          return item;
        });
        setData(newData);
      } else {
        let newData = data.map((item) => {
          if (item.postingId === e.dataItem.postingId) {
            item.amount = 0.0;
          }
          return item;
        });
      }
    }
  };

  return (
    <Grid
      data={process(data, dataState)}
      dataItemKey={"transactionNo"}
      onItemChange={itemChange}
      editField="inEdit"
      onDataStateChange={dataStateChange}
      pageable={true}
      {...dataState}
      sortable={true}
      className="flex-grow-1 overflow-auto grid-minwidth-col3-150">
      <Column
        field="date"
        title="Date"
        editable={false}
        cell={DateFormatCell}
        headerClassName="ps-4"
        width="100px"
      />
      <Column field="reference" title="Reference" width="100px" editable={false} />
      <Column field="details" title="Details" editable={false} />
      <Column
        field="vatAmount"
        title="VAT"
        editable={false}
        cell={AmountFormatCell}
        headerCell={AmountNameHeader}
        width="100px"
      />
      <Column
        field="grossAmount"
        title="Gross Amount"
        editable={false}
        cell={AmountFormatCell}
        headerCell={AmountNameHeader}
        width="120px"
      />
      <Column
        field="amountPaid"
        title="Paid"
        editable={false}
        cell={AmountFormatCell}
        headerCell={AmountNameHeader}
        width="120px"
      />
      <Column
        field="amountDue"
        title="Due"
        editable={false}
        cell={AmountFormatCell}
        headerCell={AmountNameHeader}
        width="120px"
      />
      <Column
        field="add"
        title="Select"
        editor="boolean"
        width="80px"
        className="text-center"
        headerClassName="text-center"
      />
      <Column
        field="amount"
        title="Allocate"
        editor="numeric"
        width={"150px"}
        cell={NumericCell}
        headerCell={AmountNameHeader}
        footerCell={() => (
          <td
            style={{
              textAlign: "center",
              fontWeight: "bold",
            }}>
            Total: {totalAllocatingAmount.toFixed(2)}
          </td>
        )}
      />
    </Grid>
  );
};

export default React.memo(DisbursementGrid);
